import type { AssetSystem, EquipmentType, MaintenanceObject } from '../api/types'
import { useOfflineQuery } from './useOfflineQuery'

export function useObjects() {
  return useOfflineQuery<MaintenanceObject[]>('reference:objects', '/reference/objects', { maxAgeMs: 24 * 60 * 60_000 })
}

export function useEquipmentReferences() {
  const objects = useObjects()
  const systems = useOfflineQuery<AssetSystem[]>('reference:systems', '/reference/systems', { maxAgeMs: 24 * 60 * 60_000 })
  const types = useOfflineQuery<EquipmentType[]>('reference:equipment-types', '/reference/equipment-types', { maxAgeMs: 24 * 60 * 60_000 })
  return { objects, systems, types }
}
